import { defineComponent as _defineComponent } from 'vue'
import Modal from "../Modal.vue";
  import { ref } from "vue";
  import BuilderRequestMessageSendModal from "@/components/ui/modals/BuilderRequestMessageSendModal.vue";
  import ContactUsLink from "@/components/landing/ContactUsLink.vue";
  import { POSITION, useToast } from "vue-toastification";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import { redirectWithoutRouter } from "@/helpers/redirectWithoutRouter";
  import { CALENDLY_BUILD_LINK } from "@/constants/calendlyLinks";

  const smallLayoutWidth = 990;
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderRequestMessageModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    lot: {
      type: Object,
      required: false,
    },
  },
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emits = __emit;
  const isOpenedModalRequestMessage = ref(false);
  const isOpenedModalRequestCall = ref(false);
  const toast = useToast();

  const { isDesktop } = useIsDesktop(smallLayoutWidth);

  const onClose = () => {
    isOpenedModalRequestMessage.value = false;
    emits("close");
  };

  const onSend = () => {
    toast.success("Message sent successfully", {
      position: POSITION.TOP_LEFT,
    });
  };

  const onMessage = () => {
    isOpenedModalRequestMessage.value = true;
    emits("close");
  };

  const onCall = () => {
    redirectWithoutRouter(CALENDLY_BUILD_LINK, "_blank");
    return;
  };

const __returned__ = { props, emits, isOpenedModalRequestMessage, isOpenedModalRequestCall, toast, smallLayoutWidth, isDesktop, onClose, onSend, onMessage, onCall, Modal, ref, BuilderRequestMessageSendModal, ContactUsLink, get POSITION() { return POSITION }, get useToast() { return useToast }, get useIsDesktop() { return useIsDesktop }, get redirectWithoutRouter() { return redirectWithoutRouter }, get CALENDLY_BUILD_LINK() { return CALENDLY_BUILD_LINK } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})